import { Injectable } from '@angular/core';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private isUpdating = false;
  private lastCheckedVersion: string | null = null;

  constructor(private securityService: SecurityService) {}

  async checkForUpdates() {
    if (this.isUpdating) return;

    const actualVersion = localStorage.getItem('version');

    try {
      this.securityService.getFrontVersion().subscribe({
        next: (response: any) => {
          const lastVersion = response.version;

          if (!lastVersion) return;

          if (this.lastCheckedVersion === lastVersion) return;
          this.lastCheckedVersion = lastVersion;

          if (lastVersion !== actualVersion) {
            this.isUpdating = true;
            localStorage.setItem('version', lastVersion);
            this.clearCacheAndReload();
          }
        },
        error: (error: any) => {
          console.error("ERROR verificando versión:", error);
          this.isUpdating = false;
        }
      });
    } catch (error) {
      console.error("ERROR:", error);
      this.isUpdating = false;
    }
  }

  private async clearCacheAndReload() {
    try {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      sessionStorage.clear();
      window.location.reload();
    } catch (error) {
      window.location.reload();
    }
  }
}
